import { useTranslation } from "next-i18next";
import { enums } from "@shared/constants";
import { RenewalFrequenciesMapIdType } from "@shared/constants/enums/enums-types";
import Icon from "@ui-kit/icons/Icon.web";
import { Badge, ChildBadgeProps } from "@ui-kit/data-display/Badge/Badge";

export const RenewalBadgeIcon = () => {
  const { t } = useTranslation("purchases");

  return (
    <Icon.Renewal
      boxSize={{ base: "element.md", sm: "element.xl" }}
      mr="sm"
      aria-label={t("renewal icon")}
    />
  );
};

const getRenewalText = (renewalFrequency: RenewalFrequenciesMapIdType) => {
  const { t } = useTranslation("purchases");

  const renewalObj = enums.RENEWAL_FREQUENCIES_MAP_BY_LIST.find(
    ({ id }) => id === renewalFrequency
  );

  switch (renewalObj?.id) {
    case enums.RENEWAL_FREQUENCIES_MAP_BY_ID.lifetime.id:
      return `${t(renewalObj.name, { ns: "constants" })} ${t("Membership")}`;
      break;
    case enums.RENEWAL_FREQUENCIES_MAP_BY_ID.one_time.id:
      return t(renewalObj.name);
    default:
      return `${t("Renews", { ns: "purchases" })} ${t(renewalObj?.name ?? "", {
        ns: "constants",
      })}`;
  }
};

export interface RenewalBadgeProps extends ChildBadgeProps {
  renewalFrequency: RenewalFrequenciesMapIdType | undefined;
}

export const RenewalBadge = ({
  renewalFrequency,
  isVisible = true,
}: RenewalBadgeProps) => {
  const text = getRenewalText(
    renewalFrequency ?? enums.RENEWAL_FREQUENCIES_MAP_BY_ID.one_time.id
  );

  return (
    <Badge
      icon={<RenewalBadgeIcon />}
      text={text}
      isVisible={isVisible}
      data-testid="renewal-badge"
    />
  );
};
